'use client';

import { css } from 'styled-components';

import { theme } from '../theme';

export const elevation = css`
  box-shadow: 0 1px 3px 0 var(${theme.elevation});
`;
